import React from "react";
import {
  RootGrid,
  LeftPanel,
  LogoImg,
  RightPanel,
  ContentBox,
} from "./AuthLayout.styles";

import logoSrc from "../../assets/images/logo_lg.png";

const AuthLayout = ({ children }) => (
  <RootGrid container spacing={2}>
    <LeftPanel item size={{ xs: 12, md: 5 }}>
      <LogoImg src={logoSrc} alt="logo" />
    </LeftPanel>
    <RightPanel item size={{ xs: 12, md: 7 }}>
      <ContentBox>{children}</ContentBox>
    </RightPanel>
  </RootGrid>
);

export default AuthLayout;
